import React, { useEffect, useState } from 'react';
import { modalsContent } from '../data/content';
interface ModalProps {
  activeModal: string | null;
  closeModal: () => void;
  showToast: (msg: string) => void;
}
export function Modal({
  activeModal,
  closeModal,
  showToast
}: ModalProps) {
  const [timerSeconds, setTimerSeconds] = useState(120);
  const [timerRunning, setTimerRunning] = useState(false);
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (timerRunning && timerSeconds > 0) {
      interval = setInterval(() => {
        setTimerSeconds(prev => prev - 1);
      }, 1000);
    } else if (timerSeconds === 0 && timerRunning) {
      setTimerRunning(false);
      showToast('Ritual complete!');
    }
    return () => clearInterval(interval);
  }, [timerRunning, timerSeconds, showToast]);
  if (!activeModal) return null;
  const content = modalsContent[activeModal];
  if (!content) return null;
  const formatTime = (secs: number) => {
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  };
  const handleSetTimer = (secs: number) => {
    setTimerRunning(false);
    setTimerSeconds(secs);
  };
  return <div className="fixed inset-0 bg-black/50 z-[200] flex items-end backdrop-blur-sm" onClick={closeModal} data-id="element-16">
      <div className="bg-white rounded-t-[28px] w-full max-w-[430px] mx-auto p-5 max-h-[80vh] overflow-y-auto animate-slide-up" onClick={e => e.stopPropagation()} data-id="element-17">
        <div className="w-10 h-1 bg-gray-200 rounded-full mx-auto mb-5" data-id="element-18"></div>

        <div className="text-xl font-extrabold text-text-dark mb-1.5" data-id="element-19">
          {content.title}
        </div>
        <div className="text-sm text-text-mid mb-5 leading-relaxed" data-id="element-20">
          {content.sub}
        </div>

        {content.isTimer ? <div className="text-center py-6" data-id="element-21">
            <div className="w-[140px] h-[140px] rounded-full bg-gradient-to-br from-sage-dark to-sage flex flex-col items-center justify-center mx-auto mb-4 shadow-[0_8px_30px_rgba(74,122,80,0.3)]" data-id="element-22">
              <div className="text-white text-3xl font-extrabold" data-id="element-23">
                {timerSeconds === 0 ? 'Done!' : formatTime(timerSeconds)}
              </div>
              <div className="text-white/80 text-[11px] uppercase tracking-widest mt-1" data-id="element-24">
                minutes
              </div>
            </div>
            <div className="flex justify-center gap-3 mt-4" data-id="element-25">
              <button onClick={() => handleSetTimer(30)} className="w-[54px] h-[54px] rounded-2xl bg-cream text-lg font-semibold flex items-center justify-center transition-transform active:scale-95" data-id="element-26">
                30s
              </button>
              <button onClick={() => setTimerRunning(!timerRunning)} className="w-[100px] h-[54px] rounded-2xl bg-sage-dark text-white text-lg font-bold flex items-center justify-center transition-transform active:scale-95" data-id="element-27">
                {timerRunning ? 'Pause' : 'Start'}
              </button>
              <button onClick={() => handleSetTimer(120)} className="w-[54px] h-[54px] rounded-2xl bg-cream text-lg font-semibold flex items-center justify-center transition-transform active:scale-95" data-id="element-28">
                2m
              </button>
            </div>
          </div> : <div className="flex flex-col gap-3.5" data-id="element-29">
            {content.steps.map((step: string, i: number) => <div key={i} className="flex gap-3.5 items-start" data-id="element-30">
                <div className="w-8 h-8 rounded-xl bg-sage-dark text-white flex items-center justify-center text-sm font-bold shrink-0" data-id="element-31">
                  {i + 1}
                </div>
                <div className="flex-1 pt-1.5 text-sm text-text-dark leading-relaxed" data-id="element-32">
                  {step}
                </div>
              </div>)}
          </div>}

        <button onClick={closeModal} className="w-full bg-cream rounded-xl p-3.5 text-[15px] font-semibold text-text-dark mt-5 transition-transform active:scale-95" data-id="element-33">
          Done
        </button>
      </div>
    </div>;
}